/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Style imports */
import './app.css';

/* Library imports */
// import * as Utils from "./utility/Utility";
import React, { Component } from "react";
import { GoogleLogout, GoogleLogin } from 'react-google-login';
import Lottie from 'react-lottie';
import animationData from  "./data/Complogo.json"

/* Component imports */
import LoginModal from "./LoginModal";
import ConstantsLg from "./ConstantsLg";
import { requestSignOut } from "./Services/services";

/*** End Imports ***/


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toShow: false,
            loginType: null,
            toRedirectPageIdentifier: null,
            toShowLoginView: null
        };

        this.defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                filterSize: {
                    width: '200%',
                    height: '200%',
                    x: '-50%',
                    y: '-50%',
                  }
            }
        };    

        // Add utility function to detect mobile
        this.isMobileDevice = () => {
            const isMobile = window.innerWidth <= 768;
            console.log("Mobile detection - window width:", window.innerWidth, "isMobile:", isMobile);
            return isMobile;
        };
    };

    componentDidMount() {
        window.showLoginModal = (bool, loginType) => {
            this.setState({
                toShow: bool,
                loginType: parseInt(loginType)
            });
        };
        window.logoutProfesssional = () => {
            // console.log("Called");
            this.logout();
        }

        // Comment out auto-showing login modal for testing
        // setTimeout(() => {
        //     this.setState({ toShow: true, loginType: ConstantsLg.LOGIN_TYPE.PROFESSIONAL});
        //     console.log("Auto-showing login modal");
        // }, 1000);
    };

    requestUserSignOut = () => {
        //    FIXME server call to signOut user and refresh page
        const fdata = new FormData();
        fdata.append('app_id', "1");
        requestSignOut(fdata, () => {
            const { pageIdentifier } = this.props;
            // && pageIdentifier === Constants.PAGE_IDENTIFIERS.USER_PROFILE
            if (pageIdentifier !== null) {
                window.location.replace('/')
            }
            else {
                window.location.reload(true);
            }

        }, () => {
            console.log("login failure")
        })
    };

    logout = () => {
        const auth2 = window.gapi.auth2.getAuthInstance();

        if (auth2 != null) {

            auth2.signOut()
                .then(
                    auth2.disconnect()
                        .then(this.logoutSuccess())
                )
        }
        if (window.FB && window.FB.logout) {
            window.FB.logout();
        }
    };

    logoutSuccess = () => {
        console.log("SUCCESS LOGOUT");
        // this.requestUserSignOut();
        window.onSuccessLogout();
    };


    onClickCrossIconForProfessional = () => {
        this.setState({
            toShow: false
        });
        if (window && typeof window.onLoginModalClose === "function") {
            window.onCloseLoginModal();
        }
    };

    onClickCrossIconForFreelancer = () => {
        this.setState({
            toShow: false
        });
        if (window && typeof window.onLoginModalClose === "function") {
            window.onCloseLoginModal();
        }
    };

    onCloseMobileModal = () => {
        this.setState({
            toShow: false
        });
    };

    onClickCrossIconForRecruiter = () => {
        this.setState({
            toShow: false
        });
    };

    onClickChangeUserLoginModal = (loginType) => {
        this.setState({
            loginType
        });
    };

    onLoginSuccessProfessional = () => {
        this.setState({
            toShow: false,
            loginType: null,
            toRedirectPageIdentifier: null,
            toShowLoginView: false

        });
        window.onSuccessLoginProfessional(); //this
    };

    onLoginSuccessProfessionalMobile = () => {
        this.setState({
            toShow: false,
            loginType: null,
            toRedirectPageIdentifier: null
        });
        window.onSuccessLoginProfessionalMobile();
    };

    onLoginSuccessRecruiter = () => {
        this.setState({
            toShow: false,
            loginType: null,
            toRedirectPageIdentifier: null
        });
        window.onSuccessLoginRecruiter();
    };

    onLoginSuccessFreelancer = () => {
        this.setState({
            toShow: false,
            loginType: null,
            toRedirectPageIdentifier: null
        });
        
        // Define different redirect URLs for mobile and desktop
        const redirectUrl = this.isMobileDevice() ? "/talent-partner/jobs" : "/talent-partner/active";
        
        console.log("Login successful, redirecting to:", redirectUrl);
        console.log("Current path:", window.location.pathname);
        
        // Check if we're already on the target page to prevent redirection loops
        if (!window.location.pathname.includes(redirectUrl)) {
            // Override the default window.onSuccessLoginFreelancer function
            window.onSuccessLoginFreelancer = () => {
                console.log("Executing custom redirect to:", redirectUrl);
                window.location.replace(redirectUrl);
            };
            
            window.onSuccessLoginFreelancer();
        } else {
            console.log("Already on target page, skipping redirection");
        }
    };

    handleModalClose = () => {

    };

    getLodingView = () => {
        return (
            <div className="splash-screen">
                <div className="logo-url-wrapper">
                    <img src="https://storage.googleapis.com/ck-staging/ck-logo-blue.svg.svg" />
                </div>
                <div class="loading-bar-blue">
                    <div class="blue-bar"></div>
                </div>
            </div>
        )
    };

    showAppLodingView = () => {
        this.setState({
            toShowLoginView: true
        });
    };

    removeAppLodingView = () => {
        this.setState({
            toShowLoginView: false
        });
    };
    render() {
        const {
            toShow,
            loginType,
            toRedirectPageIdentifier,
            toShowLoginView
        } = this.state;

        return (
            <div className="login-and-loading-view">
                <div className="login-modal-wrapper">
                    {
                        toShow ?
                            <LoginModal
                                loginType={loginType}
                                onProfLoginSuccess={this.onProfLoginSuccessP}
                                onRecLoginSuccess={this.onRecLoginSuccessP}
                                onClose={this.handleModalClose}
                                onClickCrossIconForProfessional={this.onClickCrossIconForProfessional}
                                onClickCrossIconForFreelancer={this.onClickCrossIconForFreelancer}
                                onCloseMobileModal={this.onCloseMobileModal}
                                onClickCrossIconForRecruiter={this.onClickCrossIconForRecruiter}
                                onClickChangeUserLoginModal={this.onClickChangeUserLoginModal}
                                toRedirectPageIdentifier={toRedirectPageIdentifier}
                                onLoginSuccessProfessional={this.onLoginSuccessProfessional}
                                onLoginSuccessProfessionalMobile={this.onLoginSuccessProfessionalMobile}
                                onLoginSuccessRecruiter={this.onLoginSuccessRecruiter}
                                onLoginSuccessFreelancer={this.onLoginSuccessFreelancer}
                                showAppLodingView={this.showAppLodingView}
                                removeAppLodingView={this.removeAppLodingView}
                            // toShowLoginView = {toShowLoginView}
                            />
                            :
                            ''
                    }
                    <GoogleLogout
                        clientId={ConstantsLg.GOOGLE_CLENT_ID}
                        ref={logoutRef => { this.logoutRef = logoutRef; }}
                        render={renderProps => (
                            <div className="logout-hidden-button">

                            </div>
                        )}
                        onLogoutSuccess={this.logoutSuccess}
                    >
                    </GoogleLogout>

                </div>
                {
                    toShowLoginView ?
                        <div className="lo">
                            <Lottie 
                            options={this.defaultOptions}
                            height={400}
                            width={400}
                            />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js